// Product gallery ("Thumbnails" layout of main-product).
// Below 1200px the list is a native scroll-snap slider; this element keeps
// the thumbnail strip in sync with it. Variant switching in global.js
// reorders [data-media-id] / [data-media-sub-id] nodes, which is picked up here.
if (!customElements.get("product-gallery")) {
	customElements.define(
		"product-gallery",
		class ProductGallery extends HTMLElement {
			connectedCallback() {
				this.list = this.querySelector("[data-gallery-list]");
				this.thumbs = this.querySelector("[data-gallery-thumbs]");
				if (!this.list || !this.thumbs) return;

				this.thumbs.addEventListener("click", this.onThumbClick.bind(this));
				this.list.addEventListener("scroll", this.onScroll.bind(this), {
					passive: true,
				});
			}

			get items() {
				// Direct children only: product-thumbnail also renders nested [data-media-id] elements
				return Array.from(this.list.querySelectorAll(":scope > .product-gallery__item"));
			}

			get thumbButtons() {
				return Array.from(this.thumbs.querySelectorAll(":scope > [data-media-sub-id]"));
			}

			onThumbClick(event) {
				const thumb = event.target.closest("[data-media-sub-id]");
				if (!thumb) return;

				const index = this.thumbButtons.indexOf(thumb);
				const item = this.items[index];
				if (!item) return;

				this.list.scrollTo({ left: item.offsetLeft, behavior: "smooth" });
				this.setActive(index);
			}

			onScroll() {
				cancelAnimationFrame(this.frame);
				this.frame = requestAnimationFrame(() => {
					const width = this.list.clientWidth;
					if (!width) return;
					this.setActive(Math.round(this.list.scrollLeft / width));
				});
			}

			setActive(index) {
				this.thumbButtons.forEach((thumb, i) => {
					const isActive = i === index;
					thumb.classList.toggle("is-active", isActive);
					if (isActive) {
						thumb.setAttribute("aria-current", "true");
						this.thumbs.scrollTo({
							left: thumb.offsetLeft - (this.thumbs.clientWidth - thumb.clientWidth) / 2,
							behavior: "smooth",
						});
					} else {
						thumb.removeAttribute("aria-current");
					}
				});
			}
		}
	);
}
